import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { loadTranslations } from '../i18n';
import { API_URL, ENDPOINTS } from '../constants/api';
import { decodeToken, getToken } from '../utils/TokenUtils';
import TopNavbarStatement from './TopNavbarStatement';
import InfoModal from './InfoModal';
import FeatherIcon from 'feather-icons-react';
import LayoutSwitcher from './LayoutSwitcher';
// import SessionWarning from './SessionWarning';
// import { useSessionTimeout } from '../utils/useSessionTimeout';
import ModalForm from './ModalForm';

const TopBar = ({ onToggleSidebar }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = getToken();

  const userId = decodeToken(token, 'id');
  const userName = decodeToken(token, 'name');
  const userImage = decodeToken(token, 'image');
  const companyName = decodeToken(token, 'companyName');
  const loginPage = decodeToken(token, 'loginPage');
  const dashboardPage = decodeToken(token, 'dashboardPage');
  const userlevel = decodeToken(token, 'userLevel');

  const [languages, setLanguages] = useState([]);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const [notifications, setNotifications] = useState([]);
  const [unreadNotifications, setUnreadNotifications] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState({});

  // const { showWarning, INACTIVE_TIME, secondsLeft, stayLoggedIn } = useSessionTimeout(token);
   const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalProps, setModalProps] = useState({
      userId: null,
      token: null,
      route: null,
    });
  useEffect(() => {
    loadTranslations();

    const fetchLanguages = async () => {
      try {
        const response = await axios.get(`${API_URL}/${ENDPOINTS.USER}/get-languages`);
        setLanguages(response.data || []);
      } catch (error) {
        console.error('Language fetch error:', error);
      }
    };

    const fetchNotifications = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/${ENDPOINTS.SYS}/reportCustom/unread-notifications`,
          { user_level: userlevel, user_id: userId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setNotifications(response.data.data || []);
        setUnreadNotifications(response.data.data?.[0]?.count || 0);
      } catch (error) {
        console.error('Notification error:', error);
      }
    };

    fetchLanguages();
    fetchNotifications();
  }, [token, userId, userlevel]);

  const handleLanguageChange = (e) => {
    localStorage.setItem('language', e.target.value);
    setLanguage(e.target.value);
    window.location.reload();
  };

  const handleOpenModal = (e, route) => {
    if (e) e.preventDefault();
    setModalProps({ userId, token, route });
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);


  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await axios.get(`${API_URL}/api/users/logout`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      console.error(error);
    } finally {
      localStorage.removeItem('authToken');
      navigate(`/login/${loginPage}`);
    }
  };

  if (!token) return null;

  return (
    <>
      <style>{`
        .ktc-topbar-container {
          position: fixed;
          top: 0;
          left: 270px;
          right: 0;
          height: 65px;
          z-index: 1020;
          background: #0f172a;
          border-bottom: 1px solid #1e293b;
          transition: left 0.25s ease;
          font-size: 14px;
        }

        @media (max-width: 991.98px) {
          .ktc-topbar-container {
            left: 0;
          }
        }
      `}</style>

      {/* {showWarning && (
        <SessionWarning
          secondsLeft={secondsLeft}
          totalSeconds={INACTIVE_TIME}
          stayLoggedIn={stayLoggedIn}
        />
      )} */}

      <header className="ktc-topbar-container d-flex align-items-center px-3">
        <div className="container-fluid p-0 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-link text-white d-lg-none p-0"
              onClick={onToggleSidebar}
            >
              <FeatherIcon icon="menu" size="22" />
            </button>

            {/* <Link
              className="text-decoration-none d-flex align-items-center gap-2"
              to={`/${dashboardPage?.replace('/', '')}`}
            >
              <span className="fw-semibold text-white fs-6">
                {companyName}
              </span>
            </Link> */}

            <TopNavbarStatement />
          </div>

          <div className="d-flex align-items-center gap-3">
            <LayoutSwitcher  />

            <select
              className="form-select form-select-sm border-0 bg-secondary bg-opacity-25 text-white shadow-none"
              value={language}
              onChange={handleLanguageChange}
              style={{ width: '100px', fontSize: '13.5px', height: '34px' }}
            >
              {languages?.map((lang) => (
                <option key={lang.id} value={lang.id} className="text-dark">
                  {t(lang.name)}
                </option>
              ))}
            </select>

            <div className="position-relative">
              <button
                className="btn btn-link text-white-50 p-1 border-0 shadow-none position-relative"
                onClick={() => setShowNotifications(!showNotifications)}
              >
                <FeatherIcon icon="bell" size="20" />
                {unreadNotifications > 0 && (
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '11px' }}>
                    {unreadNotifications}
                  </span>
                )}
              </button>

              {showNotifications && (
                <div
                  className="dropdown-menu show position-absolute end-0 mt-2 bg-dark border border-secondary border-opacity-50 shadow-lg rounded p-2"
                  style={{ minWidth: '250px', zIndex: 1050 }}
                >
                  <h6 className="dropdown-header text-white border-bottom border-secondary border-opacity-25 pb-2 px-1" style={{ fontSize: '13.5px' }}>
                    Notifications
                  </h6>
                  {notifications.length > 0 ? (
                    notifications.map((n, index) => (
                      <button
                        key={index}
                        className="dropdown-item text-white-50 rounded py-1 px-1 text-wrap"
                        style={{ fontSize: '13.5px' }}
                        onClick={() => {
                          setShowNotifications(false);
                          setSelectedNotification(n);
                        }}
                      >
                        {n.title}
                      </button>
                    ))
                  ) : (
                    <div className="text-center py-2 text-white-50" style={{ fontSize: '13.5px' }}>No unread notifications</div>
                  )}
                </div>
              )}
            </div>

            <div className="dropdown">
              <a
                className="nav-link dropdown-toggle d-flex align-items-center gap-2 text-white p-0"
                href="#"
                data-bs-toggle="dropdown"
                style={{ fontSize: '14.5px' }}
              >
                <img
                  src={`${API_URL}/${userImage}`}
                  alt="User"
                  className="rounded-circle object-fit-cover border border-secondary"
                  width="34"
                  height="34"
                  onError={(e) => { e.target.src = 'https://via.placeholder.com/34'; }}
                />
                <span className="d-none d-sm-inline fw-medium">{userName}</span>
              </a>

              <ul className="dropdown-menu dropdown-menu-end bg-dark border border-secondary border-opacity-50 shadow-lg rounded mt-2" style={{ fontSize: '14px' }}>
                <li>
                  <Link className="dropdown-item text-white-50 d-flex align-items-center gap-2" to="/profile">
                    <FeatherIcon icon="user" size="15" />
                    <span>{t('Profile')}</span>
                  </Link>
                </li>
                 <li>
                                      <Link
                                        className="dropdown-item text-white-50 d-flex align-items-center gap-2" to="/profile"
                                       
                                        onClick={(e) => handleOpenModal(e, 'change-password')}
                                      >
                                        <FeatherIcon icon="key" size="14" className="text-secondary" />
                                        {t('Change Password')}
                                      </Link>
                                    </li>
                <li>
                  <a
                    className="dropdown-item text-danger d-flex align-items-center gap-2"
                    href="#"
                    onClick={handleLogout}
                  >
                    <FeatherIcon icon="log-out" size="15" />
                    <span>{t('Logout')}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>

      {selectedNotification?.id && (
        <InfoModal
          title={selectedNotification.title}
          info={selectedNotification.message}
          onclose={() => setSelectedNotification({})}
        />
      )}
      {isModalOpen && modalProps?.route && (
        
          <ModalForm
            userId={modalProps.userId}
            token={modalProps.token}
            route={modalProps.route}
            isOpen={isModalOpen}
            onRequestClose={closeModal}
          />
        
      )}
    </>
  );
};

export default TopBar;